import { render, staticRenderFns } from "./CustomDrawer.vue?vue&type=template&id=607507b0&scoped=true"
import script from "./CustomDrawer.vue?vue&type=script&lang=js"
export * from "./CustomDrawer.vue?vue&type=script&lang=js"
import style0 from "./CustomDrawer.vue?vue&type=style&index=0&id=607507b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607507b0",
  null
  
)

export default component.exports